/* eslint-disable @wordpress/i18n-no-variables */
import {
	ColorPicker,
	RangeControl,
	SelectControl,
	Button,
} from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import './style.scss';

const BoxShadowControl = ({ label, values, onChange }) => {
	const { color, shadowType } =
		values;

	const updateBoxShadowProperty = (key, value) =>
		onChange({
			...values,
			[key]: value !== undefined ? value : values[key],
		});
	const resetColor = () => updateBoxShadowProperty('color', '#000000');

	const shadowTypeOptions = [
		{ label: 'None', value: 'none' },
		{ label: 'Outset', value: '' },
		{ label: 'Inset', value: 'inset' },
	];

	return (
		<div className="gutnm-box-shadow-wrapper">
			<p className="gutnm-box-shadow">{label}</p>
			<SelectControl
				value={shadowType}
				options={shadowTypeOptions}
				onChange={(newValue) =>
					updateBoxShadowProperty('shadowType', newValue)
				}
			/>
			{shadowType !== 'none' && (
				<>
					<div className="gutnm-colorPiker-wrapper">
						<ColorPicker
							label={__('Color', 'gutenium')}
							color={color}
							onChange={(newColor) =>
								updateBoxShadowProperty('color', newColor)
							}
							enableAlpha
							copyFormat
						/>
						<Button className="reset-button" onClick={resetColor}>
							{__('Reset', 'gutenium')}
						</Button>
					</div>
					{['offsetX', 'offsetY', 'blurRadius', 'spreadRadius'].map(
						(prop) => (
							<RangeControl
								key={prop}
								label={__(
									prop.replace(/([A-Z])/g, ' $1'),
									'gutenium'
								)}
								value={values[prop]}
								onChange={(newValue) =>
									updateBoxShadowProperty(prop, newValue)
								}
								min={
									prop === 'offsetX' || prop === 'offsetY'
										? -500
										: 0
								}
								max={500}
							/>
						)
					)}
				</>
			)}
		</div>
	);
};

export default BoxShadowControl;